module.exports = __webpack_public_path__ + "img/enabled_selected.beed8357.svg";